import store from '@sb/store'
let sb = require('@sb/util')

export default {
	name: 'Typing',
	props: ['convoKey'],

	data () {
		return {
			...store.bind(this, ['agentM', 'user']),
			isShow: false,
			timer: null,
			ev: {},
		}
	},

	mounted () {
		store.onConvoEvent(this, ev => {
			if (sb.get(ev, 'type') !== 'conversation_typing') return
			if (sb.convoKeyOfEv(ev) !== this.convoKey) return
			if (sb.get(ev, 'by.id') === this.user.id) return
			this.ev = ev
			this.isShow = true
			if (this.timer) clearTimeout(this.timer)
			this.timer = setTimeout(() => {
				this.timer = null
				this.isShow = false
			}, 1200)
		})
	},

	render () {
		var cls = this.isShow ? '' : 'typing--hidden'
		let byid = sb.get(this.ev, 'by.display_id', sb.get(this.ev, 'by.id'))
		let agentName = sb.getAgentDisplayName(store.account, sb.get(this.agentM, byid))
		return (
			<div class={`typing ${cls}`}>
				{agentName} {this.$t('typing')}
			</div>
		)
	},
}
